export default __webpack_public_path__ + "favicon-192x192.v2.e1c0d21491242a2ac9d73231e4650e26.png";